import { render } from "./LandingPage.vue?vue&type=template&id=09a83ce2&scoped=true&ts=true"
import script from "./LandingPage.vue?vue&type=script&lang=ts"
export * from "./LandingPage.vue?vue&type=script&lang=ts"

import "./LandingPage.vue?vue&type=style&index=0&id=09a83ce2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09a83ce2"]])

export default __exports__